var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#d24726;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PowerPoint_48x1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt_48",
    "data-name": "ppt 48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23,
    y: 9,
    width: 21,
    height: 30,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,10V38H24V10H43m0-2H24a2,2,0,0,0-2,2V38a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27,
    y: 28,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27,
    y: 32,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,14a6,6,0,1,0,6,6H32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,13v6h6A6,6,0,0,0,33,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28,3,3,7.38V40.62L28,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,23.47V18.1l1.4,0a3.85,3.85,0,0,1,1.2.12,2.11,2.11,0,0,1,.87.48,2,2,0,0,1,.53.83,3.6,3.6,0,0,1,.18,1.19A3.82,3.82,0,0,1,17,21.89a2.11,2.11,0,0,1-1.4,1.39,3.82,3.82,0,0,1-1.2.17H13.07M15,15l-5,.29v17l3,.18V26.41l1.69,0A8.26,8.26,0,0,0,16,26.35a6.5,6.5,0,0,0,1.22-.3,5.59,5.59,0,0,0,1.09-.52,5.5,5.5,0,0,0,1-.75,5.57,5.57,0,0,0,.74-.89,5.44,5.44,0,0,0,.53-1,6,6,0,0,0,.32-1.15,8.05,8.05,0,0,0-.28-3.78,4.2,4.2,0,0,0-1.15-1.74,4.52,4.52,0,0,0-1.89-1A8.36,8.36,0,0,0,15,15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.17a22c3ec61d516e4f7e2d521c0400ef.svg";
export { ForwardRef as ReactComponent };